import BaseCell from './popupCompanyList/listCompany/cell/BaseCell'
import CheckBoxAllCell from './popupCompanyList/listCompany/cell/CheckBoxAllCell'
import CheckboxCell from './popupCompanyList/listCompany/cell/CheckboxCell'
import PerformanceCell from './popupCompanyList/listCompany/cell/PerformanceCell'
import ScoreCell from './popupCompanyList/listCompany/cell/ScoreCell'
import StatusCell from './popupCompanyList/listCompany/cell/StatusCell'

export const MAX_INPUT_LENGTH = 255
export const REGEXP_CHARACTERS_BLOCK = [
  '"',
  ':',
  '*',
  '?',
  '"',
  '<',
  '>',
  '|',
  '\\',
  '/',
]

export const TABLE_FILTER_TITLE = [
  {
    label: '',
    key: 'checkBox',
  },
  {
    label: 'library.savePortfolio.COMPANY',
    key: 'organizationName',
  },
  {
    label: 'library.detailsPortfolios.TAX_CODE',
    key: 'taxCode',
  },
  {
    label: 'library.detailsPortfolios.STATUS',
    key: 'status',
  },
  {
    label: 'library.filterCompanies.CREDIT_SCORE',
    key: 'creditRiskScore',
  },
  {
    label: 'library.filterCompanies.PERFORMANCE_SCORE',
    key: 'performanceScore',
  },
]

export const LIST_STATUS = {
  ACTIVE: 1,
  TERMINATED: 2,
  SUSPENDED: 3,
  OTHERS: 4,
  REVOKED: 8,
  BRC_REVOKED: 9,
  DISSOLVED: 10,
  BANKRUPT: 11,
  NOT_OPERATING: 12,
}

export const STATUS_COLOR = {
  [LIST_STATUS.ACTIVE]: '#3DA967',
  [LIST_STATUS.BANKRUPT]: '#C8781A',
  [LIST_STATUS.BRC_REVOKED]: '#F58B00',
  [LIST_STATUS.DISSOLVED]: '#3A414B',
  [LIST_STATUS.NOT_OPERATING]: '#E8B714',
  [LIST_STATUS.OTHERS]: '#9C9C9C',
  [LIST_STATUS.REVOKED]: '#D375AE',
  [LIST_STATUS.SUSPENDED]: '#EC626D',
  [LIST_STATUS.TERMINATED]: '#E03643',
}

export const CELL_OPTIONS = {
  checkBox: {
    cellType: CheckboxCell,
    renderTh: () => <CheckBoxAllCell />,
  },
  organizationName: {
    cellType: BaseCell,
    tdStyle: { cursor: 'pointer', color: '#2c73e8' },
  },
  taxCode: { cellType: BaseCell },
  status: { cellType: StatusCell },
  creditRiskScore: {
    cellType: ScoreCell,
    thStyle: { justifyContent: 'center' },
  },
  performanceScore: {
    cellType: PerformanceCell,
    thStyle: { justifyContent: 'center' },
  },
}

export const PAGE_SIZE_OPTIONS = [
  { label: 20, value: 20 },
  { label: 50, value: 50 },
  { label: 100, value: 100 },
]

export const PERIOD = {
  YEAR: {
    key: 'YEAR',
    label: 'portfolio.common.YEAR',
    isI18n: true,
    value: 'Yearly',
    numberValue: 1,
  },
  QUARTER: {
    key: 'QUARTER',
    label: 'portfolio.common.QUARTER',
    isI18n: true,
    value: 'Quarterly',
    numberValue: 2,
  },
  MONTH: {
    key: 'MONTH',
    label: 'portfolio.common.MONTH',
    isI18n: true,
    value: 'Monthly',
    numberValue: 3,
  },
}

export const getPeriodValueFromNumberValue = (numberValue) => {
  return (
    Object.values(PERIOD).find((i) => i.numberValue === numberValue)?.value ||
    PERIOD.YEAR.value
  )
}
